import React, { useMemo } from "react";
import KC_Button, { KC_ButtonSize } from "../../KC_Button/KC_Button";
import { tt } from "../../../utils/i18n/i18n";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { KC_CardTitle } from "./KC_CardTitle";
import { KC_CardImage } from "./KC_CardImage";
import { KC_CardTitleSectionProps } from "./model/KC_CardTitleSectionProps";

export const KC_CardTitleSection: React.FC<KC_CardTitleSectionProps> = (
  props
) => {
  const showTitle = useMemo(() => {
    return !!(props.title || props.image || props.forceShowHeader);
  }, [props.title, props.image, props.forceShowHeader]);

  if (!showTitle) {
    return null;
  }

  return (
    <div className="w-100 d-flex flex-column gap-sm">
      {props.useMask && (
        <KC_Button
          isUpsell={true}
          text={tt("upsell_premium_button")}
          size={KC_ButtonSize.Large}
          className="d-none d-sm-flex"
          onClick={props.onMaskClick}
        />
      )}
      {props.isOnboarding &&
        !props.useMask &&
        (!!props.isSelected ? (
          <KC_Button
            isPrimary
            isTransparent={false}
            className="border d-none d-sm-flex selected-btn"
            text={tt("selectedText")}
            size={KC_ButtonSize.Large}
            showIconOnTheRight={true}
            icon={faCheckCircle}
          />
        ) : (
          <KC_Button
            isTransparent={true}
            className="d-none d-sm-flex border"
            text={tt("selectButton")}
            size={KC_ButtonSize.Large}
          />
        ))}
      <KC_CardTitle
        title={props.title || ""}
        titleClassName={props.titleClassName}
        useRemove={props.useRemove}
        handleRemove={props.handleRemove}
        isSelected={props.isSelected}
        isOnboarding={props.isOnboarding}
      />
      <div className="img-container" style={{ position: "relative" }}>
        {props.image && (
          <KC_CardImage
            title={props.title}
            image={props.image}
            imgId={props.imgId}
            useTwicpic={props.useTwicpic}
          />
        )}
      </div>
    </div>
  );
};
